<template lang="pug">
  .question-detail(v-if="item !== undefined && item !== null")
    .item-question.col-md-12
      .big-audio(v-if="item.detailLink && item.detailLink !== undefined && item.detailLink.length > 0")
        audio(id="player" controls width="50%")
          source(:src="item.detailLink" type="audio/mp3")
      .big-question {{$mycontroller.stripHtml(item.content)}}
    .item-question-number
      .col-md-12
        span {{$t('landing.exercise.question')}} {{current}}/{{total}}
    .item-question.col-md-12
      .small-question {{$mycontroller.stripHtml(item.detailContent)}}
    .item-answer.col-md-12(v-if="item.detailType === 2")
      label {{$t('landing.exercise.answer')}}
      itemFloara(@pushContent="pushContent" :answer="item.detailValueContent")
    .item-answer.col-md-12(v-else-if="item.detailType === 1 && item.detailAnswers !== null")
      .answer-charactor(v-for="(itemAnswer, index) in item.detailAnswers" @click="clickAnswer(itemAnswer)" :class="[answerIDs.includes(itemAnswer.id) ? 'current' : '']")
        label {{$mycontroller.convertToAlphabet(index)}}. {{$mycontroller.stripHtml(itemAnswer.content)}}
    .clearfix
</template>
<script>
import itemFloara from './itemFloara'
export default {
  components: {
    itemFloara
  },
  props: {
    item: Object,
    current: Number,
    total: Number,
    arrIDs: Array
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      answerIDs: this.arrIDs !== null ? this.arrIDs : [],
      content: ''
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    isMobile() {
      if (window.innerWidth < 991) return true
      return false
    },
    clickAnswer(item) {
      if (this.answerIDs == null || !this.answerIDs.includes(item.id)) this.answerIDs.push(item.id)
      else this.answerIDs.splice(this.answerIDs.indexOf(item.id), 1)
      this.item.detailAnswerID = this.answerIDs
      this.processData()
    },
    processData() {
      this.$emit('onClickAnswer', this.item)
    },
    pushContent($content) {
      this.content = $content
      this.item.detailValueContent = this.content
      this.processData()
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    }
  },
  apollo: {
  }
}
</script>
<style lang="scss">
</style>




// WEBPACK FOOTER //
// question.vue?6293f009